import { render, staticRenderFns } from "./aboutKxx.vue?vue&type=template&id=7f4b3dfc"
import script from "./aboutKxx.vue?vue&type=script&lang=js"
export * from "./aboutKxx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports